<template>
  <div class="login-box" :class="{ home: loginpage === 'home' }">
    <div class="login-tabs clearfix">
      <p class="split"></p>
      <span
        :class="{ on: currTab === index }"
        v-for="(item, index) in tablist"
        :key="index"
        @click="changeTab(index)"
        >{{ item }}</span
      >
    </div>
    <!-- 普通用户登录 -->
    <div class="input-item" v-if="currTab == 0">
      <input
        type="text"
        v-model="loginform.phonenum"
        name="phone"
        @keyup.enter="gologin"
        @focus="clear('phonenum')"
        :placeholder="$t('home.enterPhoneOrEmail')"
        autocomplete="false"
      />
      <p>{{ validatetip.phonenum }}</p>
    </div>
    <div v-if="currTab == 0">
      <div v-if="loginType !== 'captcha'">
        <div class="input-item">
          <input
            type="password"
            v-model="loginform.pwd"
            maxlength="16"
            name="pwd"
            @keyup.enter="gologin"
            @focus="clear('pwd')"
            :placeholder="$t('register.enterThePassword')"
            autocomplete="false"
          />
          <p>{{ validatetip.pwd }}</p>
        </div>
        <div class="input-item yzm">
          <!--<img src="../../index/assets/img/pwd.png">-->
          <div style="display: flex; flex-direction: row; align-items: center">
            <input
              v-model="loginform.code"
              placeholder="请输入验证码"
              type="text"
              maxlength="16"
              name="code"
              autocomplete="false"
              @blur="checkcode"
              @focus="clear('code')"
            />
            <img
              :src="codeimg"
              alt="Base64 encoded image"
              @click="getCodeImgs"
              style="height: 38px; width: 155px; background: blue; margin-top: 6px; cursor: pointer"
            />
          </div>

          <p>{{ validatetip.code }}</p>
        </div>
      </div>
      <div v-if="loginType === 'captcha'">
        <div class="input-item yzm">
          <div style="display: flex; flex-direction: row; align-items: center">
            <input
              v-model="smsCode"
              placeholder="请输入验证码"
              type="text"
              maxlength="16"
              name="code"
              autocomplete="false"
              @blur="checkSmscode"
              @focus="clear('smsCode')"
            />
            <span
              style="width: 110px; padding-top: 4px"
              @click="getSmsOrEmailCode"
              >{{ innerText }}</span
            >
          </div>

          <p>{{ validatetip.smsCode }}</p>
        </div>
        <div class="input-item yzm">
          <!--<img src="../../index/assets/img/pwd.png">-->
          <div style="display: flex; flex-direction: row; align-items: center">
            <input
              v-model="loginform.code"
              placeholder="请输入验证码"
              type="text"
              maxlength="16"
              name="code"
              autocomplete="false"
              @blur="checkcode"
              @focus="clear('code')"
            />
            <img
              :src="codeimg"
              alt="Base64 encoded image"
              @click="getCodeImgs"
              style="height: 38px; width: 155px; background: blue; margin-top: 6px; cursor: pointer"
            />
          </div>

          <p>{{ validatetip.code }}</p>
        </div>
      </div>
      <div class="btn-register">
        <a href class="btnlr-gradient" @click.prevent="gologin">{{
          $t('home.login')
        }}</a>
      </div>
      <div class="lost-pwd clearfix" v-show="!currTab">
        <!-- <a href @click.prevent="goregister()" class="left">{{$t('home.register')}}</a> -->
        <a href @click.prevent="golost('user')" class="left">{{
          $t('loginstaff.forgotPassword')
        }}</a>
        <span class="right yzmBtn" @click="yzmLogin">{{
          loginType === 'captcha' ? '验证码登录' : '账号密码登录'
        }}</span>
      </div>
      <div class="lost-pwd clearfix" v-show="currTab">
        <a href @click.prevent="golost('staff')" class="left">{{
          $t('loginstaff.forgotPassword')
        }}</a>
        <span class="right">{{ $t('home.contactAdministrator') }}</span>
      </div>
    </div>
    <!-- 工作人员登录 -->
    <div class="input-item" v-if="currTab == 1">
      <!-- maxlength="11" -->
      <template v-if="loginType !== 'ukey'">
        <input
          type="text"
          v-model="loginform.phonenum"
          name="phone"
          @keyup.enter="gologin"
          @focus="clear('phonenum')"
          :placeholder="$t('home.enterPhoneOrEmail')"
          autocomplete="false"
        />
        <p>{{ validatetip.phonenum }}</p>
      </template>
      <template v-else>
        <el-select
          class="cert-select"
          v-model="devID"
          placeholder="请选择证书"
          @blur="checkDevID"
          @change="clear('devID')"
        >
          <el-option
            v-for="item in devices"
            :key="item.devID"
            :label="item.devName"
            :value="item.devID"
          >
          </el-option>
        </el-select>
        <p>{{ validatetip.devID }}</p>
      </template>
    </div>
    <div v-if="currTab == 1">
      <div v-if="loginType === 'password'">
        <div class="input-item">
          <input
            type="password"
            v-model="loginform.pwd"
            maxlength="16"
            name="pwd"
            @keyup.enter="gologin"
            @focus="clear('pwd')"
            :placeholder="$t('register.enterThePassword')"
            autocomplete="false"
          />
          <p>{{ validatetip.pwd }}</p>
        </div>
        <div class="input-item yzm">
          <!--<img src="../../index/assets/img/pwd.png">-->
          <div style="display: flex; flex-direction: row; align-items: center">
            <input
              v-model="loginform.code"
              placeholder="请输入验证码"
              type="text"
              maxlength="16"
              name="code"
              autocomplete="false"
              @blur="checkcode"
              @focus="clear('code')"
            />
            <img
              :src="codeimg"
              alt="Base64 encoded image"
              @click="getCodeImgs"
              style="height: 38px; width: 155px; background: blue; margin-top: 6px; cursor: pointer"
            />
          </div>

          <p>{{ validatetip.code }}</p>
        </div>
      </div>
      <div v-if="loginType === 'captcha'">
        <div class="input-item yzm">
          <div style="display: flex; flex-direction: row; align-items: center">
            <input
              v-model="smsCode"
              placeholder="请输入验证码"
              type="text"
              maxlength="16"
              name="code"
              autocomplete="false"
              @blur="checkSmscode"
              @focus="clear('smsCode')"
            />
            <span
              style="width: 110px; padding-top: 4px"
              @click="getSmsOrEmailCode"
              >{{ innerText }}</span
            >
          </div>

          <p>{{ validatetip.smsCode }}</p>
        </div>
        <div class="input-item yzm">
          <!--<img src="../../index/assets/img/pwd.png">-->
          <div style="display: flex; flex-direction: row; align-items: center">
            <input
              v-model="loginform.code"
              placeholder="请输入验证码"
              type="text"
              maxlength="16"
              name="code"
              autocomplete="false"
              @blur="checkcode"
              @focus="clear('code')"
            />
            <img
              :src="codeimg"
              alt="Base64 encoded image"
              @click="getCodeImgs"
              style="height: 38px; width: 155px; background: blue; margin-top: 6px; cursor: pointer"
            />
          </div>

          <p>{{ validatetip.code }}</p>
        </div>
      </div>
      <div v-if="loginType === 'ukey'">
        <div class="input-item yzm">
          <div style="display: flex; flex-direction: row; align-items: center">
            <input
              v-model="certPwd"
              placeholder="请输入证书密码"
              type="password"
              name="certPwd"
              autocomplete="false"
              @blur="checkCertPwd"
              @focus="clear('certPwd')"
            />
          </div>
          <p>{{ validatetip.certPwd }}</p>
        </div>
      </div>
      <div class="btn-register">
        <a href class="btnlr-gradient" @click.prevent="gologin">{{
          $t('home.login')
        }}</a>
      </div>
      <div class="lost-pwd clearfix" v-show="!currTab">
        <!-- <a href @click.prevent="goregister()" class="left">{{$t('home.register')}}</a> -->
        <a href @click.prevent="golost('user')" class="right">{{
          $t('loginstaff.forgotPassword')
        }}</a>
      </div>
      <div class="lost-pwd clearfix" v-show="currTab">
        <a href @click.prevent="golost('staff')" class="left">{{
          $t('loginstaff.forgotPassword')
        }}</a>
        <!-- <span class="right">{{$t('home.contactAdministrator')}}</span> -->
        <!-- <span class="right yzmBtn" @click="yzmLogin">{{
          !isYzmLogin ? '验证码登录' : '账号密码登录'
        }}</span> -->
        <el-dropdown class="right" @command="onChangeLoginType">
          <span class="yzmBtn"
            >{{ loginTypeStr }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="password">{{
              $t('home.passwordLogin')
            }}</el-dropdown-item>
            <el-dropdown-item command="captcha">{{
              $t('home.captchaLogin')
            }}</el-dropdown-item>
            <el-dropdown-item command="ukey">{{
              $t('home.ukeyLogin')
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div
      class="res-error"
      v-if="reserror !== null"
      :class="{ hideanimate: showreserror }"
    >
      {{ reserror }}
    </div>
    <el-dialog
      class="editPass"
      :append-to-body="true"
      :title="$t('security.modifyPassword')"
      :visible.sync="passDialogVisible"
      width="30%"
      center
      :show-close="false"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm2"
        status-icon
        :rules="rules2"
        ref="ruleForm2"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('security.originalPas')"
          prop="orginPass"
          :rules="[
            {
              required: true,
              message: $t('security.originalPassword'),
              trigger: 'blur'
            }
          ]"
        >
          <el-input
            type="password"
            v-model="ruleForm2.orginPass"
            :placeholder="$t('setpwd.enterOldPassword')"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('security.newPas')" prop="pass">
          <el-input
            type="password"
            v-model="ruleForm2.pass"
            :placeholder="$t('setpwd.enterNewPassword')"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('setpwd.confirmPassword')" prop="checkPass">
          <el-input
            type="password"
            v-model="ruleForm2.checkPass"
            :placeholder="$t('setpwd.enterPasswordAgain')"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="resetForm('ruleForm2')">{{$t('centerThree.cancel')}}</el-button> -->
        <el-button type="primary" @click="passForm('ruleForm2')">{{
          $t('centerThree.confirm')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { ERR_OK, ERR_NO } from '@/publicResource/api/reConfig'
import {
  phoneLogin,
  nameLogin,
  getPublicKey,
  getCodeImg,
  getSMSCode,
  getEmailCode
} from '@/publicResource/api/apiSetting.js'
import {
  updatePassword,
  getQrcode,
  getQrcodeimg,
  gongdaoLoginSkip,
  validateCertGenRandom,
  userLoginByCert
} from '@/publicResource/api/apiUser.js'
import {
  setStore,
  getStore,
  removeStore
} from '@/publicResource/utils/utils.js'
import jsencrypt from 'jsencrypt/bin/jsencrypt.min.js'
const token = new mToken('mTokenPlugin')

export default {
  name: 'src-module-index-components-loginTab',
  props: ['loginpage'],
  data() {
    var validateOrginPass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('security.enterOriginalPas')))
      } else {
        callback()
      }
    }
    let checkpwd = (rule, value, callback) => {
      if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,16}$/.test(
          value
        )
      ) {
        callback(new Error(this.$t('setpwd.pleaseEnter')))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('security.enterPasswordAgain')))
      } else if (value !== this.ruleForm2.pass) {
        callback(new Error(this.$t('security.inconsistentPasswordsEntered')))
      } else {
        callback()
      }
    }
    return {
      tablist: [this.$t('roleEdit.normalUser'), this.$t('home.staff')],
      currTab: 0,
      reserror: '',
      weixincode: '',
      showreserror: false,
      loginform: {
        phonenum: '',
        pwd: '',
        code: '',
        uuid: ''
      },
      codeFlag: false,
      validatetip: {
        phonenum: '',
        pwd: '',
        code: '',
        smsCode: '',
        devID: '',
        certPwd: ''
      },
      logFlag: false,
      passDialogVisible: false, // 密码修改
      ruleForm2: {
        orginPass: '', // 原密码
        pass: '', // 新密码
        checkPass: '' // 确认新密码
      },
      codeimg: '',
      rules2: {
        pass: [
          {
            required: true,
            message: this.$t('setpwd.enterNewPassword'),
            trigger: 'blur'
          },
          { validator: checkpwd, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ],
        orginPass: [
          { required: true, validator: validateOrginPass2, trigger: 'blur' }
        ]
      },
      isYzmLogin: false,
      loginTypeStr: this.$t('home.passwordLogin'),
      loginType: 'password', // password 密码登录，captcha 验证码登录，ukey Ukey登录
      innerText: '获取验证码',
      smsCode: '',
      certPwd: '',
      devID: '',
      devices: [],
      cert: ''
    }
  },
  mounted() {
    this.getCodeImgs()
    let ct = getStore('loginCurrTab')
    if (ct == 1) {
      this.currTab = 1
    }
    removeStore('loginCurrTab')
    // this.getQrcodeimg();
  },
  methods: {
    // 获取短信验证码
    getSMSCodes(target) {
      let self = this
      let params = {
        mobilePhone: this.loginform.phonenum,
        // codeType: 'SMS_RESET_PASSWORD_CODE',
        codeType: 'SMS_LONGIN_USER_CODE',
        personType: self.currTab ? 'STAFF' : 'COMMON'
      }
      getSMSCode(params).then(
        res => {
          if (res.data.code === 1000) {
            let count = 59
            const stid = setInterval(function() {
              self.innerText = count + 'S'
              // target.className = 'send-code dis'
              count--
              if (count * 1 < 0) {
                self.innerText = '获取验证码'
                // target.innerText = self.$t('findpwd.resend')
                clearInterval(stid)
                // target.className = 'send-code'
              }
            }, 1000)
          } else {
            self.$message({
              type: 'error',
              message: res.data.message
            })
          }
        },
        error => {
          console.log(error)
        }
      )
    },
    // 获取邮箱验证码
    getEmailCodes(target) {
      let params = {
        email: this.loginform.phonenum,
        codeType: 'SMS_LONGIN_USER_CODE',
        personType: this.currTab ? 'STAFF' : 'COMMON'
      }
      getEmailCode(params).then(
        res => {
          if (res.data.code === 1000) {
            let count = 59
            const stid = setInterval(function() {
              self.innerText = count + 'S'
              // target.className = 'send-code dis'
              count--
              if (count < 0) {
                self.innerText = '获取验证码'
                // target.innerText = this.$t('findpwd.resend')
                clearInterval(stid)
                // target.className = 'send-code'
              }
            }, 1000)
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            })
          }
        },
        error => {
          console.log(error)
        }
      )
    },
    getSmsOrEmailCode() {
      if (!this.checkphone()) {
        return
      }
      if (this.loginform.phonenum.includes('@')) {
        this.getEmailCodes()
      } else {
        this.getSMSCodes()
      }
    },
    yzmLogin() {
      this.loginType = this.loginType === 'captcha' ? 'pwd' : 'captcha'
    },
    onChangeLoginType(command) {
      switch (command) {
        case 'password':
          this.loginTypeStr = this.$t('home.passwordLogin')
          break
        case 'captcha':
          this.loginTypeStr = this.$t('home.captchaLogin')
          break
        case 'ukey':
          this.loginTypeStr = this.$t('home.ukeyLogin')
          break
      }
      this.loginType = command
      if (command === 'ukey') {
        this.detectUKeyEnv()
      }
    },
    changeTab(index) {
      this.loginform.phonenum = null
      this.loginform.pwd = null
      this.loginform.code = null
      this.smsCode = null
      this.validatetip.phonenum = ''
      this.validatetip.pwd = ''
      this.validatetip.code = ''
      this.validatetip.smsCode = ''
      this.validatetip.devID = ''
      this.validatetip.certPwd = ''
      this.loginType = 'password'
      this.loginTypeStr = this.$t('home.passwordLogin')
      this.currTab = index
    },
    checkcode() {
      if (!this.loginform.code || !this.loginform.code.trim()) {
        this.validatetip.code = '请输入验证码'
        return false
      }
      return true
    },
    checkSmscode() {
      if (!this.smsCode || !this.smsCode.trim()) {
        this.validatetip.smsCode = '请输入验证码'
        return false
      }
      return true
    },
    checkDevID() {
      if (!this.devID || !this.devID.trim()) {
        this.validatetip.devID = '请选择证书'
        return false
      }
      return true
    },
    checkCertPwd() {
      if (!this.certPwd || !this.certPwd.trim()) {
        this.validatetip.certPwd = '请输入证书密码'
        return false
      }
      return true
    },
    /* clear (type) {
      this.validatetip[type] = ''
    }, */
    // 获取验证码
    async getCodeImgs() {
      const res = await getCodeImg()
      this.loginform.uuid = res.data.data.uuid
      this.codeimg = 'data:image/png;base64,' + res.data.data.img
    },
    // 获取二维码链接
    getQrcodeimg() {
      getQrcodeimg().then(res => {
        this.weixincode =
          'https://devghodrapi.odrcloud.cn/userGateway/user/showLoginQrCode/' +
          this.loginform.phonenum
      })
    },
    // 获取二维码登录
    getQrcode() {
      getQrcode(this.loginform.phonenum).then(
        res => {
          if (res.data.code === 1000 && res.data.data !== null) {
            let data = res.data.data
            removeStore('loginInfo')
            removeStore('loginInfouser')
            setStore('authToken', data.authToken)
            setStore('refreshToken', data.refreshToken)
            setStore('loginType', data.gongdaoLogin)
            if (this.currTab == 0) {
              setStore('loginInfouser', data.loginInfo)
              let tolink = getStore('tolink')
              if (data.loginInfo.userInfo.isRealName) {
                if (tolink) {
                  if (tolink.indexOf('/mediation') > -1) {
                    // 如果是要跳到纠纷调解页面，
                    // 已实名的话，不用调回纠纷调解页面，直接跳到选择角色页面
                    // 如果未实名，则调回纠纷调节页面，实名后跳到选择角色页面
                    if (data.loginInfo.userInfo.isRealName) {
                      let urlSuffix = tolink.substr(
                        tolink.indexOf('?'),
                        tolink.length
                      )
                      window.location.href = `/selectcharacter${urlSuffix}`
                      removeStore('tolink')
                    } else {
                      this.$router.push('/authonIden')
                    }
                  } else {
                    window.location.href = tolink
                    removeStore('tolink')
                  }
                } else {
                  // 如果是游客模式新建咨询，进入和咨询师聊天页面，在聊天页面点击登录，登录后在首页
                  let isFromChatOnline =
                    document.referrer.indexOf('consultation/chatOnline') !== -1
                  if (isFromChatOnline) {
                    window.location.href = '/home.html'
                  } else {
                    window.location.href = '/userCenter/center'
                  }
                }
              } else {
                var aLink = document.createElement('a')
                aLink.setAttribute('href', '/authonIden')
                aLink.click()
              }
            } else if (this.currTab == 1) {
              setStore('loginInfo', data.loginInfo)
              // 登录跳转
              let redicturl = this.getredicturl(data.loginInfo)
              setStore('redicturl', redicturl)
              window.location.href = redicturl
            }
          } else {
            this.reserror = res.data.message
            this.showreserror = true
            setTimeout(() => {
              this.getQrcode()
            }, 3000)
          }
        },
        err => {}
      )
    },
    codeLogin() {
      if (this.loginform.phonenum == null) {
        this.$message.error(this.$t('addservice.phoneNumberCantBeBlank'))
      } else {
        // /^1[34578]\d{9}$/
        if (
          !(getStore('locale') == 'zh_CN'
            ? /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/
            : /^\d+$/
          ).test(this.loginform.phonenum)
        ) {
          this.$message.error(this.$t('addservice.phoneNumberFormatError'))
        } else {
          this.getQrcodeimg()
          this.codeFlag = true
          setTimeout(() => {
            this.getQrcode()
          }, 2000)
        }
      }
    },
    // 跳转到公道登录界面
    goGd() {
      gongdaoLoginSkip().then(res => {
        if (res.data.code === 1000) {
          window.location.href = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 跳转注册
    goregister() {
      if (this.loginpage === 'home') {
        setStore('loginPosition', 'home')
      }
      window.location.href = '/useraction/register'
    },
    // 跳转忘记密码
    golost(type) {
      if (type === 'user') {
        setStore('loginCurrTab', 0)
        window.location.href = '/useraction/findpwd?type=user'
      } else if (type === 'staff') {
        setStore('loginCurrTab', 1)
        window.location.href = '/useraction/findpwd?type=staff'
      }
    },
    // 获取登录跳转链接
    getredicturl(loginInfo) {
      let menulist = []
      if (loginInfo) {
        for (let i = 0, l = loginInfo.userMenuInfo.length; i < l; i++) {
          let obj = {
            parent: '',
            child: []
          }
          if (loginInfo.userMenuInfo[i].parentId === 0) {
            obj.parent = loginInfo.userMenuInfo[i]
            menulist.push(obj)
            // this.rolecheck.push([]);
          }
        }
        for (let i = 0, l = loginInfo.userMenuInfo.length; i < l; i++) {
          for (let j = 0, jl = menulist.length; j < jl; j++) {
            if (loginInfo.userMenuInfo[i].parentId === menulist[j].parent.id) {
              menulist[j].child.push(loginInfo.userMenuInfo[i])
            }
          }
        }
      }
      return menulist[0].child[0].menuUrl
    },
    resetForm(formName) {
      this.passDialogVisible = false
      this.$refs[formName].resetFields()
    },
    passForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.ruleForm2.pass == this.ruleForm2.checkPass) {
            getPublicKey().then(
              res => {
                if (res.data.code === 1000) {
                  let publicKey = res.data.data
                  let encryptor = new jsencrypt()
                  encryptor.setPublicKey(publicKey)
                  let rsaOldPassWord = encryptor.encrypt(
                    this.ruleForm2.orginPass
                  )
                  let rsaNewPassWord = encryptor.encrypt(
                    this.ruleForm2.checkPass
                  )
                  let params = {
                    oldPassword: rsaOldPassWord,
                    newPassword: rsaNewPassWord,
                    publicKey: publicKey
                  }
                  this.changePassword(formName, params)
                }
              },
              error => {}
            )
          } else {
            this.$message.error(
              this.$t('security.inconsistentPasswordsEntered')
            )
          }
        } else {
          this.$message.error(this.$t('security.validationDidntPass'))
        }
      })
    },
    changePassword(formName, options) {
      // 修改密码
      this.$refs[formName].validate(valid => {
        if (valid) {
          updatePassword(options).then(
            res => {
              if (res.data.code === ERR_OK) {
                this.passDialogVisible = false
                this.$message({
                  message: this.$t('security.modificationSucceed'),
                  center: true,
                  type: 'success'
                })
                setTimeout(() => {
                  this.$router.push({ path: '/useraction/login' })
                }, 1000)
              }
              if (res.data.code === 132002 || res.data.code === 1003) {
                this.$message.error({
                  message: res.data.message,
                  center: true
                })
              }
            },
            error => {
              console.log(error)
            }
          )
        } else {
          return false
        }
      })
    },
    gologin() {
      if (this.loginType === 'ukey') {
        this.onUKeyLogin()
        return
      }
      let dologin = true
      if (!this.checkphone()) {
        dologin = false
      }
      if (this.loginType === 'pwd' && !this.checkpwd()) {
        dologin = false
      }
      if (!this.checkcode()) {
        dologin = false
      }
      if (this.loginType === 'captcha' && !this.checkSmscode()) {
        dologin = false
      }
      if (!dologin) {
        return
      }
      //   var self = this
      getPublicKey().then(
        res => {
          if (res.data.code === 1000) {
            let publicKey = res.data.data
            let encryptor = new jsencrypt()
            encryptor.setPublicKey(publicKey)
            let rsaPassWord = encryptor.encrypt(this.loginform.pwd)
            // let params = {
            //   mobilePhone: this.loginform.phonenum,
            //   password: rsaPassWord,
            //   publicKey: publicKey,
            //   uuid: this.loginform.uuid,
            //   imageCode: this.loginform.code
            // };

            let params = {}
            if (this.loginType === 'captcha') {
              // params.mobilePhone = this.loginform.phonenum
              params.publicKey = publicKey
              params.uuid = this.loginform.uuid
              params.imageCode = this.loginform.code
              params.smsCode = this.smsCode
              params.loginType =
                this.currTab == 1
                  ? 'WORK_USER_LOGIN_TYPE'
                  : 'COMMON_USER_LOGIN_TYPE'
              this.loginform.phonenum.includes('@')
                ? (params.loginName = this.loginform.phonenum)
                : (params.mobilePhone = this.loginform.phonenum)
            } else {
              // params.mobilePhone = this.loginform.phonenum
              params.password = rsaPassWord
              params.publicKey = publicKey
              params.uuid = this.loginform.uuid
              params.imageCode = this.loginform.code
              params.loginType =
                this.currTab == 1
                  ? 'WORK_USER_LOGIN_TYPE'
                  : 'COMMON_USER_LOGIN_TYPE'
              this.loginform.phonenum.includes('@')
                ? (params.loginName = this.loginform.phonenum)
                : (params.mobilePhone = this.loginform.phonenum)
            }

            // if (this.currTab == 1) {
            //   params.loginType = this.currTab == 1 ? "WORK_USER_LOGIN_TYPE" : "COMMON_USER_LOGIN_TYPE"
            // }
            const resFn = resparams => {
              if (resparams.code === 1000) {
                let data = resparams.data
                removeStore('loginInfo')
                removeStore('loginInfouser')
                setStore('authToken', data.authToken)
                setStore('refreshToken', data.refreshToken)
                if (this.currTab == 0) {
                  setStore('loginInfouser', data.loginInfo)
                  if (resparams.data.loginInfo.resetPwdTip) {
                    // 首次或者弱密码类型需要修改密码
                    this.passDialogVisible = true
                    this.$message.error(resparams.data.loginInfo.resetPwdTip)
                    return
                  }
                  let tolink = getStore('tolink')
                  // return
                  if (data.loginInfo.userInfo.isRealName) {
                    if (tolink) {
                      if (tolink.indexOf('/mediation') > -1) {
                        // 如果是要跳到纠纷调解页面，
                        // 已实名的话，不用调回纠纷调解页面，直接跳到选择角色页面
                        // 如果未实名，则调回纠纷调节页面，实名后跳到选择角色页面
                        // 判断是否是中国手机号，非中国手机号直接进入选择角色页面，否则进入扫二维码实名认证页面
                        if (
                          data.loginInfo.userInfo.isRealName &&
                          !(getStore('locale') == 'zh_CN'
                            ? /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
                            : /^\d+$/
                          ).test(this.loginform.phonenum.trim())
                        ) {
                          let urlSuffix = tolink.substr(
                            tolink.indexOf('?'),
                            tolink.length
                          )
                          window.location.href = `/selectcharacter${urlSuffix}`
                          removeStore('tolink')
                        } else {
                          this.$router.push('/goToApplets')
                        }
                      } else {
                        window.location.href = tolink
                        removeStore('tolink')
                      }
                    } else {
                      // 如果是游客模式新建咨询，进入和咨询师聊天页面，在聊天页面点击登录，登录后在首页
                      let isFromChatOnline =
                        document.referrer.indexOf('consultation/chatOnline') !==
                        -1
                      if (isFromChatOnline) {
                        window.location.href = '/home.html'
                      } else {
                        window.location.href = '/userCenter/center'
                      }
                    }
                  } else {
                    if (
                      !(getStore('locale') == 'zh_CN'
                        ? /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/
                        : /^\d+$/
                      ).test(this.loginform.phonenum.trim())
                    ) {
                      window.location.href = '/userCenter/center'
                    } else {
                      // return
                      var aLink = document.createElement('a')
                      aLink.setAttribute('href', '/goToApplets')
                      aLink.click()
                    }
                  }
                } else if (this.currTab == 1) {
                  // 登录跳转
                  // 判断登记员？
                  let redicturl = ''
                  setStore('loginInfo', data.loginInfo)
                  if (resparams.data.loginInfo.resetPwdTip) {
                    // 首次或者弱密码类型需要修改密码
                    this.passDialogVisible = true
                    this.$message.error(resparams.data.loginInfo.resetPwdTip)
                    return
                  }
                  redicturl = this.getredicturl(data.loginInfo)
                  // if (data.loginInfo.userRoles[0].roleCode === 'DISPUTE_REGISTRAR') {
                  // data.loginInfo.userMenuInfo = [{
                  //   id: 10060,
                  //   menuName: '纠纷登记列表',
                  //   menuNameEN: 'Consultation Reception List',
                  //   menuNameFT: '纠纷登记列表',
                  //   menuOrderNo: 200,
                  //   menuUrl: null,
                  //   parentId: 0
                  // }, {
                  //   id: 10061,
                  //   menuName: '登记纠纷',
                  //   menuNameEN: 'Consultation Reception List',
                  //   menuNameFT: '登记纠纷',
                  //   menuOrderNo: 200,
                  //   menuUrl: '/greffier/adddispute',
                  //   parentId: 10060
                  // }, {
                  //   id: 10062,
                  //   menuName: '纠纷登记列表',
                  //   menuNameEN: 'Consultation Reception List',
                  //   menuNameFT: '纠纷登记列表',
                  //   menuOrderNo: 200,
                  //   menuUrl: '/greffier/disputelist',
                  //   parentId: 10060
                  // }]
                  //   setStore('loginInfo', data.loginInfo)
                  //   redicturl = '/greffier/adddispute'
                  // } else {
                  //   setStore('loginInfo', data.loginInfo)
                  //   redicturl = this.getredicturl(data.loginInfo)
                  // }
                  setStore('redicturl', redicturl)
                  window.location.href = redicturl
                }
              } else {
                if (resparams.code === 1003) {
                  this.getCodeImgs()
                }
                this.reserror = resparams.message
                this.showreserror = true
                setTimeout(() => {
                  this.showreserror = false
                }, 2000)
              }
            }
            if (
              /@/.test(this.loginform.phonenum.trim()) &&
              (this.currTab === 0 || this.currTab === 1)
            ) {
              //   let loginType = ''
              //   if (this.currTab === 0) {
              //     loginType = 'COMMON_USER_LOGIN_TYPE'
              //   } else if (this.currTab === 1) {
              //     loginType = 'WORK_USER_LOGIN_TYPE'
              //   }

              // let params = {
              //   loginName: this.loginform.phonenum,
              //   password: rsaPassWord,
              //   publicKey: publicKey,
              //   loginType: loginType,
              //   smsCode: this.smsCode
              // };
              nameLogin(params).then(
                res => {
                  resFn(res.data)
                },
                err => {}
              )
            } else {
              phoneLogin(params).then(
                res => {
                  resFn(res.data)
                },
                err => {}
              )
            }
          }
        },
        erro => {}
      )
    },
    handleUkeyLogin(resparams) {
      if (resparams.code === 1000) {
        let data = resparams.data
        removeStore('loginInfo')
        removeStore('loginInfouser')
        setStore('authToken', data.authToken)
        setStore('refreshToken', data.refreshToken)
        let redicturl = ''
        setStore('loginInfo', data.loginInfo)
        redicturl = this.getredicturl(data.loginInfo)
        setStore('redicturl', redicturl)
        window.location.href = redicturl
      } else {
        this.reserror = resparams.message
        this.showreserror = true
        setTimeout(() => {
          this.showreserror = false
        }, 2000)
      }
    },
    checkphone() {
      if (!this.loginform.phonenum || !this.loginform.phonenum.trim()) {
        this.validatetip.phonenum = this.$t('home.enterPhoneOrEmail')
        return false
      }
      if (/@/.test(this.loginform.phonenum.trim())) {
        if (
          !/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
            this.loginform.phonenum.trim()
          )
        ) {
          this.validatetip.phonenum = this.$t('home.emailFormatError')
          return false
        }
      } else {
        // /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
        if (
          !(getStore('locale') == 'zh_CN'
            ? /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/
            : /^\d+$/
          ).test(this.loginform.phonenum.trim())
        ) {
          this.validatetip.phonenum = this.$t(
            'addservice.phoneNumberFormatError'
          )
          return false
        }
      }
      return true
    },
    checkpwd() {
      if (!this.loginform.pwd || !this.loginform.pwd.trim()) {
        this.validatetip.pwd = this.$t('register.enterThePassword')
        return false
      }
      return true
    },
    clear(type) {
      this.validatetip[type] = ''
    },
    onError(msg) {
      this.$message.warning(msg)
      //   this.loading = false
    },
    detectUKeyEnv() {
      let ret = token.SOF_LoadLibrary(token.GM3000)
      if (ret != 0) {
        this.onError('加载控件失败，错误码：' + token.SOF_GetLastError())
        return
      }
      let deviceName = token.SOF_EnumDevice()
      ret = token.SOF_GetDeviceInstance(deviceName, '')
      if (ret != 0) {
        this.onError(
          '绑定应用失败，确定是否初始化Key，错误码：' + token.SOF_GetLastError()
        )
        return
      }
      const cerList = token.SOF_GetUserList()
      this.devices = cerList.map(item => {
        return {
          devID: item[1],
          devName: item[0]
        }
      })
    },
    verifyUserPin() {
      let ret = 0
      let strRes = ''
      let pin = this.certPwd
      ret = token.SOF_Login(pin)
      if (ret != 0) {
        strRes = '验证用户密码失败'
        let lastErr = token.SOF_GetLastError()
        let retryCount = token.SOF_GetPinRetryCount()
        this.onError(
          strRes + ' 错误码：' + lastErr + ' 剩余次数：' + retryCount
        )
      }
      return ret
    },
    exportUserCert(containerName, cerType) {
      let cert = token.SOF_ExportUserCert(containerName, cerType)
      if (cert != null && cert != '') {
        this.cert = cert
      } else {
        this.onError('获取证书信息失败，错误码:' + token.SOF_GetLastError())
      }
    },
    onUKeyLogin() {
      if (!this.checkDevID()) {
        return
      }
      if (!this.checkCertPwd()) {
        return
      }
      //   this.loading = true
      let ret = this.verifyUserPin()
      if (ret != 0) return
      this.exportUserCert(this.devID, '1')
      validateCertGenRandom({
        userSignCertB64: this.cert,
        container: this.devID
      })
        .then(res => {
          token.SOF_SetDigestMethod(token.SGD_SM3)
          const signedDataB64 = token.SOF_SignData(
            this.devID,
            true,
            // eslint-disable-next-line no-undef
            _Base64encode(res.data.data.randomData)
          )
          if (signedDataB64 !== null && signedDataB64 !== '') {
            userLoginByCert({
              userSignCert: this.cert,
              signedDataB64,
              randomData: res.data.data.randomData
            })
              .then(res => {
                this.handleUkeyLogin(res.data)
              })
              .catch(e => {
                this.onError(e)
              })
          } else {
            this.onError('数据签名失败，错误码:' + token.SOF_GetLastError())
          }
        })
        .catch(e => {
          this.onError(e)
        })
    }
  }
}
</script>
<style scoped>
.wxcode {
  widows: 400px;
  height: 400px;
}
</style>

<style lang="scss">
.login-box {
  float: right;
  width: 340px;
  height: 380px;
  padding: 0 30px;
  margin-top: 75px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
  .login-tabs {
    margin: 35px 0 18px;
    position: relative;
    .split {
      position: absolute;
      top: 5px;
      left: 50%;
      width: 1px;
      height: 20px;
      background-color: #d8d8d8;
    }
    span {
      font-size: 20px;
      line-height: 30px;
      color: #333;
      position: relative;
      display: block;
      float: left;
      margin: 0 45px;
      cursor: pointer;
      &.on {
        color: #3595f4;
      }
      &.on:after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -10px;
        width: 100%;
        height: 3px;
        background-color: #3595f4;
        border-radius: 1px;
      }
    }
  }
  .cert-select {
    width: 100%;
    height: 35px;
    input {
      padding-left: 0;
    }
  }
  .res-error {
    width: 240px;
    padding: 10px;
    word-break: break-all;
    line-height: 20px;
    white-space: normal;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    font-size: 14px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -20px 0 0 -120px;
    opacity: 0;
    visibility: hidden;
    &.hideanimate {
      opacity: 1;
      visibility: visible;
      transition: all 0.3s;
    }
  }
  .lost-pwd {
    padding: 0px 0;
    a {
      font-size: 14px;
      color: #3595f4;
      padding: 0 5px 3px;
    }
    span {
      font-size: 14px;
      color: #666;
      padding: 0 5px;
    }
    .yzmBtn {
      cursor: pointer;
      color: #3595f4;
    }
  }
  h6 {
    font-size: 20px;
    color: #333;
    text-align: center;
    padding: 25px 0 5px;
  }
  .input-item {
    padding-top: 17px;
    border-bottom: 1px solid #d8d8d8;
    position: relative;
    input {
      width: 100%;
      height: 35px;
      line-height: 35px;
      font-size: 14px;
      color: #666;
      outline: none;
      border: none;
      &::placeholder {
        color: #b2b2b2;
      }
    }
    .code {
      width: 200px;
    }
    span {
      color: #3595f4;
      width: 80px;
      text-align: right;
      display: inline-block;
      font-size: 14px;
      cursor: pointer;
      &.dis {
        color: #b2b2b2;
        cursor: default;
      }
    }
    p {
      position: absolute;
      left: 0;
      bottom: -19px;
      background: url(../assets/common/icon_validate_err.png) no-repeat left
        center;
      padding-left: 18px;
      color: #e90a0a;
      font-size: 12px;
      line-height: 15px;
    }
  }
  .btn-register {
    text-align: center;
    padding: 30px 0 15px;
    a {
      display: block;
      height: 49px;
      line-height: 49px;
      border-radius: 3px;
      font-size: 18px;
      color: #fff;
      &.dis {
        opacity: 0.6;
        cursor: default;
      }
    }
  }
  .check-agr {
    font-size: 14px;
    color: #666;
  }
  .el-checkbox__label {
    color: #666;
    a {
      color: #666;
    }
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #f0a635;
    border-color: #f0a635;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #666;
    a {
      color: #666;
    }
  }
}
.login-box.home {
  width: 260px;
  height: 310px;
  padding: 0 20px;
  margin: 0;
  .login-tabs {
    margin: 12px 0 0;
    .split {
      top: 7px;
      height: 16px;
    }
    span {
      font-size: 16px;
      margin: 0 32px;
    }
    span.on:after {
      bottom: -1px;
    }
  }
  .input-item {
    input {
      height: 30px;
      line-height: 30px;
      padding-top: 5px;
    }
  }
  .btn-register {
    padding: 25px 0 10px;
    a {
      line-height: 40px;
      height: 40px;
    }
  }
  .yzm {
    input {
      margin: 0 !important;
    }
    img {
      margin: 0 !important;
      height: 32px !important;
      border-radius: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/module/index/components/loginTab.vue